export default function InfoIcon({
  size = 'w-[18px] h-[18px]',
  color = '#717680',
}) {
  return (
    <svg
      className={size}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4375 8.4375H9V12.375H9.5625"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.85937 6.75C9.32536 6.75 9.70312 6.37224 9.70312 5.90625C9.70312 5.44026 9.32536 5.0625 8.85937 5.0625C8.39338 5.0625 8.01562 5.44026 8.01562 5.90625C8.01562 6.37224 8.39338 6.75 8.85937 6.75Z"
        fill={color}
      />
    </svg>
  );
}
